import React from "react";
import { getFormScopeMeta } from "./formCategoryUtils";

const FormScopeBadge = ({ scope = "crm", className = "" }) => {
  const meta = getFormScopeMeta(scope);

  return (
    <span
      className={`form-scope-badge form-scope-badge--${scope} ${className}`.trim()}
      aria-label={`Form scope: ${meta.label}`}
    >
      {meta.label}
    </span>
  );
};

export default FormScopeBadge;
